import classnames from 'classnames';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { prettyMoney } from '@scramble/utils';
import { useGetLoyaltyStatus } from '@/query/queries/loyalty/useGetLoyaltyStatus';
import { MyLink } from '@/components/MyLink';
import { Image } from '@/components/Image';
import { APP_LINKS } from '@/helpers/links';
import IconChevronRight from '@scramble/design-system/icons/chevron-right.svg';
import s from './index.module.scss';

export const LoyaltyStatus = () => {
  const location = useLocation();
  const { data: status } = useGetLoyaltyStatus();
  const { t } = useTranslation('loyalty');
  const isAnotherPage = !location.pathname.includes(APP_LINKS.loyaltyProgram);
  const isActive = !isAnotherPage || status?.participation_rate >= 0;

  if (!status) return null;

  return (
    <MyLink
      href={APP_LINKS.loyaltyProgram}
      className={s.wrapper}
      style={{ cursor: isAnotherPage ? 'pointer' : 'unset' }}
    >
      <h2
        className={classnames(
          s.title,
          isAnotherPage ? 'f-headline-xs' : 'f-42',
          'f-500',
        )}
      >
        {t('loyalty_status.your_current_investor_level')}
        {isAnotherPage && (
          <img src={IconChevronRight} alt="icon" width={28} height={28} />
        )}
      </h2>
      <div className={classnames(s.container, isActive && s.loyalty_active)}>
        <div className={s.header}>
          <div className={s.icon}>
            <div className={s.icon_inner}>
              <img src={status.icon_url} alt="wallet" width={20} height={20} />
            </div>
          </div>
          <h3 className="f-headline-2xs f-500">{status.level_name}</h3>
        </div>
        <div className={s.cards}>
          <div className={s.card}>
            <div className={s.card_text}>
              <div className="f-body-md f-500">
                {t('loyalty_status.net_cash_flow')}
              </div>
              <div className="f-body-md f-500" style={{ whiteSpace: 'nowrap' }}>
                {prettyMoney(status.net_inflow)}
              </div>
            </div>
            <div
              className="f-body-sm"
              style={{
                color: 'var(--Text-Neutral-Secondary-Base, #4A4D5A)',
              }}
            >
              {t('loyalty_status.net_cash_flow_description')}
            </div>
          </div>
          <div className={s.card}>
            <div className={s.card_text}>
              <div className="f-body-md f-500">
                {t('loyalty_status.participation_rate')}
              </div>
              <div className="f-body-md f-500">{status.participation_rate}</div>
            </div>
            <div
              className="f-body-sm"
              style={{ color: 'var(--Text-Neutral-Secondary-Base, #4A4D5A)' }}
            >
              {t('loyalty_status.participation_rate_description')}
            </div>
          </div>
        </div>
      </div>
    </MyLink>
  );
};
